module.exports = __webpack_public_path__ + "static/media/dan-benefits.750a3d9a.png";